import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value", "id", "name", "checked"]
const _hoisted_2 = ["for"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.options, (option, index) => {
      return (_openBlock(), _createElementBlock("fieldset", {
        key: index,
        class: _normalizeClass(`${_ctx.type && _ctx.type == `horizon` ? `fl` : ``} mr20 mb5`)
      }, [
        (option && index < _ctx.limit)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(`${_ctx.type && _ctx.type == `horizon` ? `fl` : ``}`)
            }, [
              _createElementVNode("input", {
                type: "radio",
                value: option.id || option,
                id: `${_ctx.optionName}_${option.id || index}`,
                name: _ctx.optionName,
                checked: (option.id || option) == _ctx.defaultOption,
                style: {"width":"20px","-webkit-transform":"scale(1.5)","transform":"scale(1.5)","margin":"3px 5px 10px"},
                class: _normalizeClass(`fl ${_ctx.optionName ? _ctx.optionName : `a`}_radio pointer mr3`),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectId && _ctx.selectId(...args)))
              }, null, 10, _hoisted_1),
              _createElementVNode("label", {
                class: "fl pointer",
                for: `${_ctx.optionName}_${option.id || index}`
              }, _toDisplayString(option.name || option), 9, _hoisted_2),
              (_ctx.type != `horizon`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("br", null, null, -1),
                    _createElementVNode("br", null, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}